import { render, staticRenderFns } from "./PlantillaPrincipal.vue?vue&type=template&id=759cc78e&"
import script from "./PlantillaPrincipal.vue?vue&type=script&lang=js&"
export * from "./PlantillaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports